module.exports = __webpack_public_path__ + "static/img/product_09.4d87da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_09.jpg
// module id = FuGw
// module chunks = 2